import React,{useState,useEffect,useRef} from 'react'
import {toast} from 'react-toastify'
import Sections from '../dropdowns/SingleSection'
const AddSection = ({onClose ,theme,action,project}) => {
  console.log(action)
  const [sectionName, setSectionName] = useState('');
  const [section, setSection] = useState('');
  const cancelButtonRef = useRef(null);
  
    const handleSubmit =()=>{
      if(action==='Add'){
      
      toast.success(`${sectionName} added successfully in ${project}`)
    }
    else if(action==='Edit'){
      toast.success('Section updated successfully')
  }
  else{
    toast.error('Invalid action')
  }
    }
  return (
    <div>
      {action==="Add" && (
        <>
        <label className='block text-sm font-medium mb-2'>
       Section Name 
      </label>
      <input type="text"
      value={sectionName}
      onChange={(e) => setSectionName(e.target.value)}
       className={`bg-gray-50 border border-gray-300 text-sm rounded-md focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`} />
        </>
      )}
      {action==="Edit" && <Sections section={section} onChange={(e)=>setSection(e.target.value)} />}
         <div className=" px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse justify-between">
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      className={` py-2 px-4 rounded-md  hover:bg-blue-700 text-white text-md`}
                    >
                      Add
                    </button>
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:w-auto"
                      onClick={onClose}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                  </div>
    </div>
    
  )
}

export default AddSection